import { useTranslation } from "react-i18next";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Outcome } from "../helpers";
import { useResultStyles } from "./styles";

interface Props {
  mode: Outcome["mode"];
}

export default function TestProgress({ mode }: Props) {
  const { t } = useTranslation("storage");
  const resultClasses = useResultStyles();
  const classes = useStyles();
  const textKey =
    mode === "save" ? "externalAI.result.saving" : "externalAI.result.testing";

  return (
    <Alert
      severity="info"
      icon={<CircularProgress size={18} />}
      className={`${resultClasses.result} ${classes.running}`}
      data-testid="external-ai__result-running"
    >
      {t(textKey)}
    </Alert>
  );
}

const useStyles = makeStyles(theme => ({
  running: {
    alignItems: "center",
    borderColor: "#c5e6f2",
    backgroundColor: "#f3f9fc",
    color: theme.palette.primary.dark,
    fontWeight: 500,
  },
}));
